import { Component, Input, OnInit } from 'angular-ts-decorators';
import {
  IconDefinition,
  faExclamationCircle,
  faQuestionCircle,
} from '@fortawesome/pro-solid-svg-icons';

/**
 * Component that displays question mark and a popover with info on hover.
 *
 * # Attributes
 * * text - message to be displayed
 * * icon - icon to override the default (?) one
 *
 * # Deprecated attributes
 * * isWarning - set to true for exclamation icon
 */
@Component({
  selector: 'swInfo',
  template: require('./sw-info.html').default,
  bindings: {
    text: '@',
    icon: '<',
    isWarning: '<',
  },
})
export class SwInfoComponent implements OnInit {
  @Input('@') text: string;
  @Input() icon: IconDefinition;
  @Input() isWarning: boolean;

  ngOnInit() {
    if (angular.isUndefined(this.icon)) {
      if (this.isWarning) {
        this.icon = faExclamationCircle;
      } else {
        this.icon = faQuestionCircle;
      }
    }
  }
}
